<template>
  <div class="col-list">
    <div v-for="(item, index) in houseList" :key="index + 10">
      <van-cell v-if="item.property" :class="item.property.propertyStatus === 3 || item.property.propertyStatus === 0 ? 'col_saled' : ''" @click="goUrl(item)">
        <van-card :title="item.property.titleWithCulture">
          <!-- 图片部分 -->
          <div slot="thumb" class="col-card__thumb">
            <div class="icon reviewed" v-if="item.property.propertyLabel && item.property.propertyLabel[1]"><img src="../assets/vr.gif" /></div>
            <div v-if="item.property.propertyLabel && item.property.propertyLabel[3] && !item.property.propertyLabel[1]">
              <svg class="icon reviewed" aria-hidden="true">
                <use xlink:href="#icon-yingpian"></use>
              </svg>
            </div>
            <!-- 收藏按钮状态取消 -->
            <!-- <div class="col-icon">
              <img src="@/assets/soucang.png" style="width: 20px; height: 20px" alt="" />
            </div> -->
            <!-- <img class="img-hse" :src="item.property.imagePath|imgResize('company')" onerror="errorImg(this)" /> -->
            <img class="img-hse" v-lazy="pub.imgResize(item.property.imagePath, 'company')" onerror="errorImg(this)" />
            <!--封盤 已租或已售 -->
            <p v-if="item.property.propertyStatus === 3 || item.property.propertyStatus === 0" class="saled">{{ item.property.propertyStatusWithCulture }}</p>
          </div>
          <!-- 置顶标签 -->
          <div slot="tag" class="col-tag">
            <p v-if="item.property.topType" :class="['col-top',{colsel:item.property.topType==1?true:false}]">{{ item.property.topTypeWithCulture }}</p>
            <p :class="lang.type === 'en-us' ? 'col-reviewd-en' : 'col-reviewd'" v-if="item.property.isVerifyLabel">{{ lang.verifyLabel }}</p>
            <!-- 图片总数 -->
            <p class="imageNumber" v-if="item.property.imageNumber">{{item.property.imageNumber}}</p>
          </div>
          <!-- 平面图和业主盘标签 -->
          <div slot="tag" class="col-label">
            <p :class="lang.type === 'en-us' ? 'col-landlord-d-en' : 'col-landlord-d'" v-if="item.property.propertySource === 1">
              <img class="icon" src="@/assets/yezhupan.svg" />
              <span :class="lang.type === 'en-us' ? 'landlord-en' : 'landlord'">{{ lang.Landlord }}</span>
            </p>
            <p :class="lang.type === 'en-us' ? 'col-plane-d-en' : 'col-plane-d'" v-if="item.property.propertyLabel && item.property.propertyLabel[7]">
              <img class="icon" src="@/assets/pingmiantu.svg" />
              <span :class="lang.type === 'en-us' ? 'plane-en' : 'plane'">{{ lang.plane }}</span>
            </p>
          </div>
          <!-- 分类标签 -->
          <div slot="tags" class="col-desc col-adress">
            <!-- 屋苑+期数 -->
            <span class="card-tags">{{ item.property.estateNameWithCulture }} {{ item.property.phaseWithCulture }}</span>
          </div>
          <!-- 间隔+层数 -->
          <div slot="tags" class="col-desc">
            <!-- <span>Open Style 5+ Bathroom(s) | Ground Floor</span> -->
            <span v-if="item.property.roomNumberWithCulture">{{ item.property.roomNumberWithCulture }}&nbsp;</span>
            <span v-if="item.property.toiletNumberWithCulture">{{ item.property.toiletNumberWithCulture }}&nbsp;</span>
            <span v-if="item.property.unitFloorWithCulture">{{ item.property.toiletNumberWithCulture ? '|&nbsp;' + item.property.unitFloorWithCulture : item.property.unitFloorWithCulture }}</span>

            <div class="reducePrice" v-if="item.property.isReducePaidSalePrice || item.property.isReduceRentPrice">
              <span v-if="item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1" class="saleform"
                >{{ lang.saleFormPaid }} &nbsp;</span
              >
              <span class="decmid">{{ tool.getPrice(item.property.rentalType === 1 ? item.property.firstPaidSalePrice : item.property.firstRentPrice, lang.type).replace(/[^0-9|$|.]/gi, '') }}
              
              <span v-if="(item.property.firstRentPrice>100000&& item.property.rentalType ==2) || item.property.rentalType === 1">{{
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.firstPaidSalePrice : item.property.firstRentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.firstPaidSalePrice : item.property.firstRentPrice, lang.type).length - 1)}}</span>
                </span>
              <span class="redRatio">&nbsp;{{ item.property.rentalType === 1 ? item.property.reducePaidSalePriceRatio : item.property.reduceRentPriceRatio }}%</span>
            </div>
            <div class="reducePrice" v-if="item.property.isReduceUnPaidSalePrice">
              <span class="saleform">{{ lang.saleFormUnpaid }} &nbsp;</span>
              <span class="decmid">{{ tool.getPrice(item.property.firstUnPaidSalePrice, lang.type).replace(/[^0-9|$|.]/gi, '') }}
              {{
                  tool
                    .getPrice(item.property.firstUnPaidSalePrice, lang.type)
                    .substring(tool.getPrice(item.property.firstUnPaidSalePrice, lang.type).length - 1)
                }}
                </span>
              <span class="redRatio">&nbsp;{{ item.property.reduceUnPaidSalePriceRatio }}%</span>
            </div>
          </div>
        </van-card>
        <!-- 价格部分 -->
        <div class="bh-price col-adress" v-if="item.property.paidSalePrice || item.property.rentPrice">
          <div class="bh-plane"></div>
          <!--已補地價1未补，2已补，自由市場 綠表價/白居二  只展示固定类型楼盘-->
          <span v-if="item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1" class="saleform"
            >{{ lang.saleFormPaid }} &nbsp;</span
          >
          <span class="card-price"> {{ tool.getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type).replace(/[^0-9|$|.]/gi, '') }} </span
          >
          <span
            :class="lang.type === 'en-us' ? 'card-price-small-en' : 'card-price-small'"
            v-if="
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type).length - 1)
                .search(/[\d]/gi) === -1
            "
            >{{
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type).length - 1)
            }}</span
          >
          <div class="col-price">
            <div class="practical col-adress">
              <span class="practical-top">
                {{ tool.getAreaToText('', item.property.saleableArea, lang.type, item.property.isVerifyArea) }}
              </span>
              <span v-if="item.property.saleableAvgPaidPrice" class="practical-bottom" style="font-size: 11px">
                {{ tool.getAvgPriceToText('', item.property.saleableAvgPaidPrice, lang.type) }}
              </span>
              <span v-if="item.property.saleableAvgPaidPrice && item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1"
                >{{ lang.saleFormPaid }} &nbsp;</span
              >
            </div>
            <div class="build col-adress">
              <span class="build-top">
                {{ tool.getAreaToText(item.property.buildingArea, '', lang.type, item.property.isVerifyArea) }}
              </span>
              <span v-if="item.property.buildingAvgPaidPrice" class="build-bottom" style="font-size: 11px">
                {{ tool.getAvgPriceToText(item.property.buildingAvgPaidPrice, '', lang.type) }}
              </span>
              <span v-if="item.property.buildingAvgPaidPrice && item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1"
                >{{ lang.saleFormPaid }} &nbsp;</span
              >
            </div>
          </div>
        </div>
        <!-- 居屋/夹屋 售价问题-->
        <div
          class="bh-price col-adress"
          v-if="item.property.unPaidSalePrice && item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1"
        >
          <div class="bh-plane"></div>
          <!--已補地價1未补，2已补，自由市場 綠表價/白居二  只展示固定类型楼盘-->
          <span class="saleform">{{ lang.saleFormUnpaid }} &nbsp;</span>
          <span class="card-price"> {{ tool.getPrice(item.property.unPaidSalePrice, lang.type).replace(/[^0-9|$|.]/gi, '') }} </span
          ><span
            :class="lang.type === 'en-us' ? 'card-price-small-en' : 'card-price-small'"
            v-if="
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.unPaidSalePrice : item.property.rentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.unPaidSalePrice : item.property.rentPrice, lang.type).length - 1)
                .search(/[\d]/gi) === -1
            "
            >
            {{
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.unPaidSalePrice : item.property.rentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.unPaidSalePrice : item.property.rentPrice, lang.type).length - 1)
            }}
            </span
          >
          <div class="col-price">
            <div class="practical col-adress">
              <span class="practical-top" v-if="!item.property.paidSalePrice">
                {{ tool.getAreaToText('', item.property.saleableArea, lang.type, item.property.isVerifyArea) }}
              </span>
              <span class="practical-bottom" style="font-size: 11px">
                {{ tool.getAvgPriceToText('', item.property.saleableAvgUnPaidPrice, lang.type) }}
              </span>
              <span v-if="item.property.saleableAvgUnPaidPrice">{{ lang.saleFormUnpaid }}</span>
            </div>
            <div class="build col-adress">
              <span class="build-top" v-if="!item.property.paidSalePrice">
                {{ tool.getAreaToText(item.property.buildingArea, '', lang.type, item.property.isVerifyArea) }}
              </span>
              <span class="build-bottom" style="font-size: 11px">
                {{ tool.getAvgPriceToText(item.property.buildingAvgUnPaidPrice, '', lang.type) }}
              </span>
              <span v-if="item.property.buildingAvgUnPaidPrice">{{ lang.saleFormUnpaid }}</span>
            </div>
          </div>
        </div>
        <!-- 标签 -->
        <div class="bottom">
          <div class="col-plane"></div>
          <div class="info-property-tags">
            <!-- 住宅 单栋式大厦 -->
            <template v-if="item.property.propertyCategoryWithCulture">
              <span class="tags-span property col-adress"
                >{{ item.property.propertyCategoryWithCulture }}
                <span v-for="(it, i) in item.property.subCategoryInfos" :key="i+10"> {{ it.name }}<span v-if="i !== item.property.subCategoryInfos.length - 1"> | </span></span>
              </span>
            </template>
            <template v-if="item.property.rentLabel">
              <span class="tags-span property col-adress" v-for="(it, i) in item.property.rentLabel" :key="i+10" v-if="i == 3 || i == 4 || i == 5 || i == 8">{{ it }}</span>
            </template>
            <template v-if="item.property.propertyTag">
              <span v-for="(it, i) in item.property.propertyTag" :key="i+10">
                <span class="tags-span col-adress" v-if="i < 5">{{ it.propertyTagName }}</span>
              </span>
            </template>
          </div>
        </div>
        <div class="col-remark-width">
          <!-- <p class="bh-company col-adress">{{getCompany(item.property.companyNameWithCulture,item.property.propertySource)}}</p> -->
          <p class="col-remark" v-if="item.remark">{{ lang.collectionNotes }}：{{ item.remark }}</p>
          <!-- <p v-else class="col-remark col-adress"></p> -->
        </div>
      </van-cell>
    </div>
  </div>
</template>

<script>
import pub from '../../common/public';
import lang from '../../common/language/history';
import tool from '../../common/js/tools.js';
const _conf = require('../../common/js/_conf');
export default {
  data() {
    return {
      tool,
      lang,
    };
  },
  props: {
    houseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  created() {
    this.lang.type = this.pub.getLang();
  },
  methods: {
    getCompany(company, property) {
      if (!company && property === 1) {
        return this.lang.landlord;
      } else if (!company && property === 2) {
        return this.lang.agency;
      } else if (company) {
        return company;
      }
    },
    // 租标签
    rentLabel(val) {
      if (val) {
        if (val[3] && val[4]) {
          return `${this.lang.shortRent}${this.lang.sublet}`;
        } else if (val[3]) {
          return this.lang.shortRent;
        } else if (val[4]) {
          return this.lang.sublet;
        }
      }
    },
    goUrl(item) {
      const base = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
      const type = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/';
      if (item.property.rentalType === 1) {
        location.href = `${base}/${type}buy-property-${item.property.propertyID}/`;
      } else if (item.property.rentalType === 2) {
        location.href = `${base}/${type}rent-property-${item.property.propertyID}/`;
      }
    },
  },
};
</script>
<style scoped>
.van-card:not(:first-child) {
  margin: 0;
}
.col-list {
  margin-left: 15px;
  box-sizing: border-box;
}
.van-cell {
  padding: 15px 0px 10px 0;
  border-bottom: 1px solid #ebedf0;
  box-sizing: border-box;
  position: relative;
  top: 0;
  left: 0;
}
.col_saled {
  opacity: 0.55;
}
.van-card__title {
  font-size: 17px;
  color: #333333;
  font-weight: bold;
  min-height: 45px;
  max-height: 46px;
  line-height: 23px;
  padding-right: 15px;
}
.col-desc {
  font-size: 12px;
  line-height: 19px;
  color: #666666;
}
.reducePrice {
  margin-bottom: 4px;
  height: 16px;
  line-height: 16px;
}
.decmid {
  text-decoration: line-through;
  font-family: PingFangSC-SNaNpxibold;
  font-weight: 600;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  line-height: 16px;
}
.saleform {
  font-size: 10px !important;
  color: #999999 !important;
}
.redRatio {
  font-weight: bold;
  font-size: 12px !important;
  color: #333333 !important;
}
.col-adress {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/* 图片部分 */
.van-card__thumb,
.col-card__thumb {
  width: 120px;
  height: 90px;
  /* overflow: hidden; */
  position: relative;
  top: 0;
  left: 0;
  text-align: center;
  background: url('//static.house730.com/m/images/house-bg.png');
  background-size: cover;
}
.van-card__thumb {
  margin-right: 16px;
}
.van-card__thumb img {
  width: 120px;
  height: 90px;
  /* max-height: initial; */
}
.reviewed {
  font-size: 36px;
  position: absolute;
  left: 36%;
  bottom: 30%;
}
.col-vr {
  position: absolute;
  left: 5px;
  bottom: 5px;
  width: 24px;
  height: 24px;
}
.col-icon {
  position: absolute;
  /* top:-4px; */
  right: 4px;
  font-size: 20px;
  z-index: 5;
}
.saled {
  font-size: 17px;
  color: #ffffff;
  opacity: 0.55;
  background: #292630;
  width: 120px;
  height: 90px;
  line-height: 90px;
  position: absolute;
  left: 0;
  top: 0;
}
/* 分类标签部分 */
.van-card {
  padding: 0;
  background-color: #fff;
}
.van-ellipsis {
  overflow: inherit;
}
.van-card__content {
  text-align: left;
  height: auto;
  box-sizing: border-box;
  /* border-bottom:1px solid #EEEEEE; */
  padding: 0 15px 5px 0;
}
.van-card__tag {
  top: 0;
}
.col-plane {
  min-width: 120px;
}
.col-landlord-d > img,
.col-landlord-d-en > img,
.col-plane-d > img,
.col-plane-d-en > img {
  width: 14px;
  height: 14px;
  display: inline-block;
}
.col-landlord-d {
  width: 60px;
  height: 18px;
  padding: 0px 3px;
  background: #ffe3e3;
  border-radius: 2px;
  box-shadow: 0 0 0 1px #ed1c24;
  line-height: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 1px;
  margin-top: 8px;
}
.col-landlord-d-en {
  width: 80px;
  height: 18px;
  padding: 0px 3px;
  background: #ffe3e3;
  border-radius: 2px;
  box-shadow: 0 0 0 1px #ed1c24;
  line-height: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 1px;
  margin-top: 8px;
}
.col-plane-d {
  width: 60px;
  height: 18px;
  padding: 0px 3px;
  background: #e3f0ff;
  border-radius: 2px;
  box-shadow: 0 0 0 1px #056de0;
  line-height: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 1px;
  margin-top: 8px;
}
.col-plane-d-en {
  width: 80px;
  height: 18px;
  padding: 0px 3px;
  background: #e3f0ff;
  border-radius: 2px;
  box-shadow: 0 0 0 1px #056de0;
  line-height: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 1px;
  margin-top: 8px;
}
.landlord,
.landlord-en {
  line-height: 18px;
  margin-left: 2px;
  font-size: 12px;
  color: #ed1c24;
  transform: scale(0.95);
  transform-origin: 50% 100%;
}
.plane,
.plane-en {
  line-height: 18px;
  margin-left: 2px;
  font-size: 12px;
  color: #056de0;
  transform: scale(0.95);
  transform-origin: 50% 100%;
}
.col-tag {
  display: flex;
}
.col-tag p {
  height: 15px;
  line-height: 15px;
  font-size: 10px;
  color: #ffffff;
  padding: 0 2px;
  /* margin:4px 0 0 4px; */
}
.imageNumber {
  position: absolute;
  top: 71px;
  left: 87px;
  width: 24px;
  height: 18px;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  line-height: 18px;
}
.col-label {
  width: 60px;
  position: absolute;
  top: 90px;
}
.col-top {
  background: #ff2119ff;
  margin: 5px 0 0 6px;
  /* border-radius: 0 0 8px 0; */
}
.colsel{
  background: #f4a100;
}
.col-reviewd {
  background-color: #0054a6;
  margin: 75px 0 0 -28px !important;
}
.col-reviewd-en {
  background-color: #0054a6;
  margin: 74px 0 0 -52px !important;
}
.card-tags {
  font-size: 13px;
  color: #4d73bf;
}
/* 标签部分 */
.info-property-tags {
  max-height: 125px;
  margin-left: 16px;
  padding-right: 15px;
  text-align: left;
  display: inline-block;
}
.tags-span {
  color: #617e9d;
  margin: 0px 4px 4px 0;
  padding: 0 4px;
  font-size: 12px;
  line-height: 16px;
  display: inline-block;
  background-color: #eef8ff;
  max-width: 200px;
  font-family: PingFangSC-Regular;
}
.property {
  color: #536ea6;
  background-color: #dfe9ff;
}
/* 价格部分 */
.van-card__bottom {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 13px;
}
.bh-price {
  display: flex;
  align-items: center;
  padding-right: 15px;
  padding-bottom: 9px;
}
.bh-plane {
  margin-right: 16px;
  width: 120px;
}
.bh-plane .icon {
  display: inline-block;
  width: 14px;
  height: 14px;
}
.bh-plane > .col-plane {
  margin-top: 8px;
}
.saleform {
  font-size: 10px;
  color: #333;
}
.card-price {
  font-size: 20px;
  color: #ed1c24;
  font-weight: bold;
}
.card-price-small {
  margin-top: 2px;
  font-size: 14px;
  color: #ed1c24;
}
.card-price-small-en {
  margin-top: 5px;
  font-size: 14px;
  color: #ed1c24;
}
.col-price {
  display: flex;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-direction: row;
  align-items: flex-start;
}
.practical {
  padding-left: 4px;
  font-size: 11px;
  color: #999999;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.practical span {
  font-size: 11px;
  line-height: 14px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.build span {
  line-height: 14px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.build {
  padding-left: 4px;
  font-size: 11px;
  color: #999999;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.build-top {
  font-size: 11px;
  color: #333333;
}
.practical-top .practical-bottom {
  display: block;
  color: red;
}
.practical-top {
  font-size: 11px;
  color: #333333;
}
.bottom {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.col-remark-width {
  padding-right: 16px;
}
.col-remark {
  display: inline-block;
  margin-top: 2px;
  height: 18px;
  font-size: 12px;
  color: #999999;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bh-company {
  margin: 5px 0 0 136px;
  font-size: 11px;
  color: #333333;
  height: 20px;
  padding-right: 15px;
}
</style>
